// extracted by mini-css-extract-plugin
export default {"menu-icon":"index_menu-icon__lGqhG","open":"index_open__oftDE"};